<template>
	<div :class="['trick-wrapper', { owned, selected }]">
		<Vector class="icon" :src="icon" contain="width" />
		<div class="content">
			<div class="title">{{ title }}</div>
			<ScoreModifier v-bind="$attrs" />
		</div>
	</div>
</template>

<script>
import ScoreModifier from '@/components/game/shop/ScoreModifier';
import Vector from '@/components/base/Vector';

export default {
	name: 'Trick',
	components: {
		ScoreModifier,
		Vector,
	},
	props: {
		id: {
			type: Number,
			required: true,
		},
		icon: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		owned: {
			type: Boolean,
			required: true,
		},
		selected: {
			type: Boolean,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
	.trick-wrapper {
		cursor: pointer;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: $alt-color;
		position: relative;
		margin: auto;
		width: 0;
		height: 100%;
		padding: 20px;
		padding-right: 60%;
		border: 5px solid $off-white-dark;
		border-radius: $border-radius;
		background-color: $alt-color;

		@include desktop { border-width: 7px; }

		&.owned { background: $alt-color; }
		&.selected { background: $alt-color-dark; }

		&:not(.owned) {
			cursor: not-allowed;
			border-color: $body-txt-color;
			background-image: url('~@/assets/images/lock.svg');
			background-color: $alt-color-dark;
			background-repeat: no-repeat;
			background-position: center;
			background-size: 30%;
		}
	}

	.icon {
		display: inherit;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		margin: auto;
		max-width: 60%;
		max-height: unset;
		height: 100%;

		.trick-list.basic-grid & {
			@media (any-hover: none) { display: none; }
		}

		.trick-wrapper:not(.owned) & { display: none; }
	}

	.content {
		flex: 0 0 60%;
		color: $body-txt-color;
		text-align: right;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		margin: auto;
		max-width: 100%;
		height: 100%;
		background-color: $off-white-dark;
		text-align: center;
		opacity: 0;
		transition: opacity $ui-transition-duration;

		.trick-list.basic-grid & {
			@media (any-hover: none) { opacity: 1; }
		}

		.trick-slot  & {
			@media (any-hover: none) { display: none; }
		}

		&:hover { opacity: 1; }

		.title {
			text-align: center;
			margin-bottom: .5em;
		}

		.trick-wrapper:not(.owned) & { display: none; }
	}

	.title {
		white-space: nowrap;
		text-align: right;
		font-family: $body-font-script;
		font-size: $font-size-xx-lg;
		line-height: $line-height-snug;

		@include mobile { font-size: $font-size-lg; }
		@include tablet { font-size: $font-size-lg; }
	}
</style>



// WEBPACK FOOTER //
// src/components/game/shop/TrickBasic.vue